<template>
    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form class="form" @submit.prevent="handleSubmit(onSubmit)">
            <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 10px 25px">
                <div>
                    <span>Tên kra <span class="text-danger">*</span></span>
                    <ValidationProvider vid="Tên kra" name="Tên kra" rules="required"
                                        v-slot="{ errors }">
                        <el-input type="text" ref="name" name="name"
                                  placeholder="Nhập tên kra"
                                  v-model=form.name />
                        <div class="fv-plugins-message-container">
                            <div data-field="name" data-validator="notEmpty"
                                 class="fv-help-block">{{ errors[0] }}
                            </div>
                        </div>
                    </ValidationProvider>
                </div>
                <div>
                    <span>Yêu cầu thành phẩm <span class="text-danger">*</span></span>
                    <ValidationProvider vid="Kết quả kra" name="Kết quả kra" rules="required"
                                        v-slot="{ errors }">
                        <el-input type="text" ref="result" name="result"
                                  placeholder="Nhập kết quả"
                                  v-model=form.result />
                        <div class="fv-plugins-message-container">
                            <div data-field="name" data-validator="notEmpty"
                                 class="fv-help-block">{{ errors[0] }}
                            </div>
                        </div>
                    </ValidationProvider>
                </div>
                <div>
                    <span>Thời gian hoàn thành <span class="text-danger">*</span></span>
                    <ValidationProvider vid="Thời gian hoàn thành" name="Thời gian hoàn thành" rules="required"
                                        v-slot="{ errors }">
                        <el-input type="text" ref="hours" name="hours"
                                  placeholder="Nhập thời gian hoàn thành"
                                  v-model=form.hours />
                        <div class="fv-plugins-message-container">
                            <div data-field="name" data-validator="notEmpty"
                                 class="fv-help-block">{{ errors[0] }}
                            </div>
                        </div>
                    </ValidationProvider>
                </div>
                <div>
                    <span>Trọng số <span class="text-danger">*</span></span>
                    <ValidationProvider vid="Trọng số" name="Trọng số" rules="required"
                                        v-slot="{ errors }">
                        <el-input type="text" ref="percent" name="percent"
                                  placeholder="Nhập trọng số"
                                  v-model=form.percent />
                        <div class="fv-plugins-message-container">
                            <div data-field="name" data-validator="notEmpty"
                                 class="fv-help-block">{{ errors[0] }}
                            </div>
                        </div>
                    </ValidationProvider>
                </div>
            </div>
            <div style="display: flex; justify-content: end; margin: 20px 0">
                <el-button type="info" @click="closeDialog">Huỷ</el-button>
                <el-button type="primary" native-type="submit">Xác nhận</el-button>
            </div>
        </form>
    </ValidationObserver>
</template>

<script>
import {TEAM_LEAD_CREATE_KRA} from "@/core/services/store/kpi/kpi.module";

export default {
    name: 'FormCreateKra',
    props: {
        userInfo: {
            type: Object,
            required: true,
            default: null
        }
    },
    data() {
        return {
            form: {
                name: null,
                result: null,
                hours: null,
                percent: null,
            },
        }
    },
    methods: {
        onSubmit() {
            const payload = {
                user_id: this.userInfo.user_id,
                name: this.form.name,
                request_result: this.form.result,
                number_hour: this.form.hours,
                percent_score: this.form.percent,
            }
            this.$store.dispatch(TEAM_LEAD_CREATE_KRA, payload).then(res => {
                if (!res.error) {
                    this.$message.success('Tạo kra thành công')
                    this.$emit('getListKra')
                    this.$emit('closeDialog')
                }
            })
        },
        disabledDate(time) {
            const now = new Date()
            const currentMonthValue = now.getFullYear() * 12 + now.getMonth()
            const checkMonthValue = time.getFullYear() * 12 + time.getMonth()

            return checkMonthValue < currentMonthValue
        },
        closeDialog() {
            this.$emit('closeDialog')
        }
    }
}
</script>

<style scoped>

</style>
